import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faArrowsH } from '@fortawesome/pro-light-svg-icons/faArrowsH';
import { faCalendarDay } from '@fortawesome/pro-light-svg-icons/faCalendarDay';
import { faSuitcase } from '@fortawesome/pro-light-svg-icons/faSuitcase';

export const registerLightIcons = (library: FaIconLibrary) => {
    library.addIcons(faCalendarDay, faArrowsH, faSuitcase);
};
